<div
  class="error-control-wrapper"
  *ngIf="control.errors && control.errors.notifications"
  [ngStyle]="{
    'margin-top': offset + 'px' || '0px',
    'margin-bottom': -offset + 'px' || '0px'
  }">
  <span *ngFor="let item of control.errors.notifications">{{ item }}</span>
</div>
